import React, { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AuthContext from "../../context/userAuth.context";
import Button from "@mui/material/Button";
import axios from "axios";
import Swal from "sweetalert";

import CharacterContext from "../../context/CharacterContext";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";

import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Padding } from "@mui/icons-material";
const CategoryModal = (props) => {
  const { authenticationData, Access } = useContext(AuthContext);

  const { Categories } = useContext(CharacterContext);

  const [Selected, setSelected] = useState([]);

  useEffect(() => {
    if (props.value && props.value.categoryIds) {
      setSelected(JSON.parse(props.value.categoryIds));
    }
  }, []);

  const [PreviewVideoURL, setPreviewVideoURL] = useState(null);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const send = () => {
    if (Access == "US2") {
      let formdata = new FormData();
      formdata.append("id", props.value.id);
      formdata.append("categoryIds", JSON.stringify(Selected));
      formdata.append("videopreivewlink", PreviewVideoURL);
      axios
        .post(
          authenticationData.ApiBaseURL +
            "/api/Category/AssignAgencyTemplateToCategory",
          formdata,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((res) => {
          if (res.status) {
            props.setCategorModalOpen(false);
            Swal("Excellent", "Template Marked as Agency Template", "success");
            
          }
        });
      return;
    }
    fetch(
      authenticationData.ApiBaseURL +
        `/api/Category/AssignCategory?Id=${
          props.value.id
        }&categoryIds=${JSON.stringify(Selected)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.status) {
          props.setCategorModalOpen(false);
          Swal("Excellent", "Category Assigned", "success");
        }
      })
      .catch();
  };

  //   const Tick = ({ lmc, index, Selected, setSelected }) => {
  //     const [check, setcheck] = useState(false);
  //     const select = (params) => {
  //       if (Selected.length != 0) {
  //         let found = false;
  //         for (let i = 0; i < Selected.length; i++) {
  //           if (Selected[i] == params) {
  //             found = true;
  //           }
  //         }
  //         if (!found) {
  //           const array = Array.from(Selected);
  //           array.push(params);
  //           setSelected(array);
  //         }
  //       } else {
  //         const array = Array.from(Selected);
  //         array.push(params);
  //         setSelected(array);
  //       }
  //     };

  //     useEffect(() => {
  //       if (Selected.length != 0) {
  //         for (let i = 0; i < Selected.length; i++) {
  //           if (Selected[i] == lmc.id) {
  //             setcheck(true);
  //           }
  //         }
  //       }
  //     }, [Selected]);

  //     return (
  //       <div
  //         key={index.toString()}
  //         className="dropUpperDiv py-2 px-2"
  //         onClick={() => {
  //           select(lmc.id);
  //           setcheck(!check);
  //         }}
  //       >
  //         {check && (
  //           <span className="material-icons DropDownIcon noHover">done </span>
  //         )}
  //         <span className="noHover dropdown-item">
  //           <span className="ml-4">{lmc.name}</span>
  //         </span>
  //       </div>
  //     );
  //   };
  const [catName, setcatName] = React.useState([]);
  useEffect(() => {
    setcatName([]);
  }, [props.CategorModalOpen]);
  const handleChange = (event, obj) => {
    const {
      target: { value },
    } = event;
    setcatName(typeof value === "string" ? value.split(",") : value);
    const array = Array.from(Selected);
    array.push(obj.key.split(".$")[1]);
    setSelected(array);
    console.log(Selected);
  };
  return (
    <>
      <Dialog
        open={props.CategorModalOpen}
        onClose={() => props.setCategorModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title mr-4"
          style={{ marginRight: "100px" }}
        >
          Choose following options to assign this project.
          <IconButton
            onClick={() => props.setCategorModalOpen(false)}
            style={{ position: "absolute", right: "10px", top: "10px" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {Access == "US2" && (
            <TextField
              label="Preview Video Link"
              onChange={(e) => setPreviewVideoURL(e.target.value)}
              variant="outlined"
              color="secondary"
              sx={{ mb: 3, mt: 3 }}
              fullWidth
              value={PreviewVideoURL}
            />
          )}
          <FormControl sx={{ width: 300, mb: 3 }}>
            <InputLabel id="demo-multiple-checkbox-label">
              Category Name
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={catName}
              onChange={(event, obj) => handleChange(event, obj)}
              input={<OutlinedInput label="Select Category" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {Categories.length != 0 &&
                Categories.map((lmc, index) => (
                  <MenuItem key={lmc.id} value={lmc.name}>
                    <Checkbox
                      value={lmc.id}
                      checked={catName.indexOf(lmc.name) > -1}
                      label="asd"
                    />
                    <ListItemText primary={lmc.name} />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <DialogActions>
            <Button onClick={() => props.setCategorModalOpen(false)}>
              Cancel
            </Button>
            <Button variant="contained" disableElevation onClick={send}>
              Save Changes
            </Button>
          </DialogActions>
          {/* <MenuList>
              <MenuItem>
                {Access == "US2" && (
                  <div>
                    <TextField
                      label="Preview Video Link"
                      onChange={(e) => setPreviewVideoURL(e.target.value)}
                      variant="outlined"
                      color="secondary"
                      sx={{ mb: 3 }}
                      fullWidth
                      value={PreviewVideoURL}
                    />
                  </div>
                )}
              </MenuItem>

              {Categories.length != 0 &&
                Categories.map((lmc, index) => (
                  <>
                    <MenuItem>
                      <Tick
                        lmc={lmc}
                        index={index}
                        Selected={Selected}
                        setSelected={setSelected}
                      />
                    </MenuItem>
                  </>
                ))}

              <MenuItem>
                <div>
                  <button onClick={send}>save</button>
                  <button
                    style={{ float: "right" }}
                    onClick={() => {
                      setshowpop(false);
                    }}
                  >
                    cancel
                  </button>
                </div>
              </MenuItem>
            </MenuList> */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CategoryModal;
